export default "__VITE_ASSET__506860d5__"